import {AnnotationMenuComponent} from './AnnotationMenuComponent'
import './scss/annotationmenu.scss'

const AnnotationMenuPackage = {
    name: 'dw-annotation-menu',
    configure: function(config) {
        config.addComponent('dw-annotation-menu', AnnotationMenuComponent)
    }
}

export {AnnotationMenuPackage}
